<template>
  <QuesStarRating v-if="showQues(QType.RATING)" :ques="ques" />
  <QuesSlider v-else-if="showQues(QType.SLIDER)" :ques="ques" />
  <QuesText v-else-if="showQues(QType.TEXT)" :ques="ques" />
  <QuesNumeric v-else-if="showQues(QType.NUMERIC)" :ques="ques" />
  <QuesChoiceMultiple v-else-if="showQues(QType.CHOICE_MULTIPLE)" :ques="ques" />
  <QuesChoice v-else-if="showQues(QType.CHOICE)" :ques="ques" />
  <QuesDate v-else-if="showQues(QType.DATE)" :ques="ques" />
  <QuesDateTime v-else-if="showQues(QType.DATE_TIME)" :ques="ques" />
  <QuesMatrix v-else-if="showQues(QType.MATRIX)" :ques="ques" />
  <QuesFile v-else-if="showQues(QType.FILE)" :ques="ques" />
  <div v-else>未知題型</div>
</template>

<script>
import QuesStarRating from '../components/QuesStarRating'
import QuesSlider from '../components/QuesSlider'
import QuesText from '../components/QuesText'
import QuesNumeric from '../components/QuesNumeric'
import QuesChoice from '../components/QuesChoice'
import QuesChoiceMultiple from '../components/QuesChoiceMultiple'
import QuesDate from '../components/QuesDate'
import QuesMatrix from '../components/QuesMatrix'
import QuesDateTime from '../components/QuesDateTime'
import QuesFile from '../components/QuesFile'
export default {
  components: {
    QuesStarRating,
    QuesSlider,
    QuesText,
    QuesChoice,
    QuesNumeric,
    QuesChoiceMultiple,
    QuesDate,
    QuesDateTime,
    QuesMatrix,
    QuesFile
  },
  props: {
    // 題目本人
    ques: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    QType() {
      return this.$store.state.QType
    }
  },
  methods: {
    showQues(qtype) {
      return this.ques.questItemType === qtype.name
    }
  }
}
</script>

<style lang="scss" scoped></style>
